var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8455 0.272219L13.7302 1.16678C14.0899 1.53051 14.0899 2.12426 13.7302 2.48798L13.2875 2.93559L11.0962 0.720484L11.5388 0.272875C11.8986 -0.0908489 12.4864 -0.0908489 12.8455 0.272219ZM2.53229 0.262389C1.13943 0.262389 0 1.41451 0 2.82287V11.4395C0 12.8479 1.13943 14 2.53293 14H11.0547C12.4469 14 13.587 12.8479 13.587 11.4395V4.56547L12.1001 6.0682V11.4395C12.1001 12.0215 11.6296 12.4966 11.0547 12.4966H2.53229C1.95674 12.4966 1.48619 12.0208 1.48619 11.4395V2.82287C1.48619 2.24091 1.95674 1.76512 2.53229 1.76512H8.15102L9.6372 0.262389H2.53229ZM5.07105 9.0278L5.42947 7.72888L5.78725 6.42931L6.71409 7.36712L7.64093 8.30429L6.35632 8.6667L5.07105 9.0278ZM12.8241 3.40352L10.6327 1.18841L6.08215 5.78968L8.27287 8.00479L12.8241 3.40352Z",
    fill: "#50596B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d2b623e1a6847947eae9cfdd6671d43c.svg";
export { ForwardRef as ReactComponent };